
import deliceDesDoudou from '../assets/images/delice/IMG_60982.jpg';
import bizzon from '../assets/images/Bizon/IMacWorkSpace2_Mockups.png';
import ra from '../assets/images/Revesargentes/RA_Laptop_Mockup2.jpg';
import extaz from '../assets/images/Extaz/extazcard.png';
import rear from '../assets/images/realisation/7e782018044163.562c2dd0f3477.jpg';
import b4s from '../assets/images/B4S/iPhoneX_Mockups.png';
import msww from '../assets/images/msww/msww.png';
import moise from '../assets/images/Moise/moise.png';
import joe from '../assets/images/Joevent/Sans titre-22.jpg';


const cards = [
    { id: 5, title: 'Rêves Argentés', description: '', color: '#0246a4', image: ra},

   // { id: 2, title: 'Card 2', description: 'Description for card 2', type:"talk"},
    { id: 2, title: 'Del ile s des doudou', description: '', color: '#0246a4',image: deliceDesDoudou},
    { id: 3, title: 'B4Star', description: '', color: '#0246a4', image: b4s },
    { id: 4, title: 'Extaz Cafée', description: '', color: '#0246a4', image:extaz},
    { id: 8, title: 'BIZZON', description: '', color: '#0246a4', image:bizzon},

    { id: 6, title: 'Samovard', description: '', color: '#0246a4', image: rear },
    { id: 14, title: 'Jo event', description: '', color: '#0246a4', image: joe},
    { id: 11, title: 'Papa Moïse', description: '', color: '#f3641a', image: moise },
    { id: 1, title: 'Ms WoodWork', description: '', color: '#0246a4',image: msww},
    //{ id: 13, title: 'WWW', description: '', color: '#14addc' },
   // { id: 15, title: '•••', description: '', color: 'rgba(87,20,220,0.43)', type:"talk" },

];
export default cards;
